import { type Ref, type ReactElement } from 'react'
import { ActionableTooltip } from '@capture/capture-components'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Pages } from '~/routing'
import { _ } from '~/assets/localization/util'
import { getUserReadOnlyStatus } from '~/state/currentUser/selectors'
import { TestFlagService } from '~/API/services/TestFlagService'

type ElementRenderFunc = (
    isReadOnlyUser: boolean,
    triggerProps?: any,
    forwardRef?: Ref<any>,
) => ReactElement

interface ReadonlyTooltipWrapperProps {
    renderElement: ElementRenderFunc
}

export const ReadonlyTooltip = ({
    renderElement,
}: ReadonlyTooltipWrapperProps): ReactElement => {
    const isReadOnlyUser = useSelector(getUserReadOnlyStatus)
    const navigate = useNavigate()

    if (isReadOnlyUser && TestFlagService.isEnabled('read-only-tooltip')) {
        return (
            <ActionableTooltip
                description={_('readonly_tooltip')}
                actionButtonText={_('subscribe')}
                onActionButtonClick={() => navigate(Pages.SettingsStorage.url)}>
                {renderElement(isReadOnlyUser)}
            </ActionableTooltip>
        )
    }

    return renderElement(isReadOnlyUser)
}
